import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AttributeModel } from 'src/app/main/dynamic/model/attribute.model';
import { OptionModel } from 'src/app/main/dynamic/model/option.model';
import { AuthenticationService } from 'src/app/service/auth.service';
import { SecurityService } from 'src/app/service/security.service';
import swal from "sweetalert2";

@Component({
  selector: 'app-button-link',
  templateUrl: './button-link.component.html',
  styleUrls: ['./button-link.component.scss']
})
export class ButtonLinkComponent implements OnInit {

  @Input() button: AttributeModel

  constructor(
    private authService: AuthenticationService,
    private securityService: SecurityService,
    private router: Router,
    private spinner: NgxSpinnerService,) {
  }

  ngOnInit() {
  }

  getClassName(): string {
    let classOpt = this.getOptionValue("class")

    if(classOpt) {
      return classOpt
    } else {
      return "btn btn-primary"
    }
  }

  private getOptionValue(key: string) {
    let options = this.button.options

    if (options) {
      let classOpt = options.find(o => o.key.toLowerCase() == key)

      if (classOpt && classOpt.value) {
        return classOpt.value
      }
    }
  }

  getTaskName(): string {
    if(!this.button) {
      return 'Clique'
    }

    let titleOpt = this.button.options.find(opt => opt.key.toLowerCase() == "title")

    if(titleOpt) {
      return titleOpt.value
    }

    return this.button.key
  }

  getDynamicIconClass(): string {
    if (!this.button) {
      return 'fa fa-external-link';
    }

    const iconOpt = this.button.options
      .find(opt => opt.key.toLowerCase() == "icon-class");

    if(iconOpt) {
      return `fa fa-${iconOpt.value}`;
    } else {
      return 'fa fa-external-link';
    }
  }

  execute() {
    this.accessLink(this.button)
  }

  private accessLink(linkAttr: AttributeModel) {
    this.spinner.show()
    let accessCodeRule = linkAttr.options.find(opt =>
      opt.key.toLowerCase() == "AccessCodeRule".toLowerCase());

    const targetOpt = linkAttr.options.find(opt =>
      opt.key.toLowerCase() == "target");

    if(accessCodeRule) {
      this.navigateByRule(accessCodeRule, linkAttr);
    } else {
      this.spinner.hide();
      window.open(linkAttr.value, targetOpt?.value == "self" ? '_self' : '_blank');
    }
  }

  private navigateByRule(accessCodeRule: OptionModel, linkAttr: AttributeModel) {
    if (accessCodeRule.value.toLowerCase() == "Replace Last Segment With New Access Code".toLowerCase()) {
      let url = new URL(linkAttr.value)
      let segments = url.pathname.split('/');
      let accessCode = segments.pop() || segments.pop();
      let loggedUserName = this.authService.getUser().userName;
      this.securityService.createUserAccess(accessCode, loggedUserName)
          .subscribe((access) => {
              this.spinner.hide();
              if (access) {
                  let newAccesCode = access.newAccessCode;
                  let newPath = segments.join("/")
                  newPath += `/${newAccesCode}`
                  window.open(`${url.origin}${newPath}`, '_blank');
              }
          }, (error) => this.handleHttpError(error));
    }
  }

  private handleHttpError(error: any) {
    this.spinner.hide();


    if(error.status == 401) {
      this.authService.logout()
      this.router.navigate(['login']);
    } else if(error.status == 403) {
      swal.fire("Atenção", "Este usuário não tem permissão para acessar este conteúdo.")
        .then(() => this.router.navigate([""]).then(() => swal.close()))
    } else if(error.message) {
      swal.fire("Atenção", error.message, "error").then(() => {
        if(error.goBackToHome) {
          this.router.navigate([""]).then(() => swal.close())
        }
      })
    } else {
      swal.fire("Atenção", "Algo errado aconteceu; Por favor, tente novamente.", "error")
    }
  }
}
